import i18n from "../../utilities/i18n";
import { marginErrorMap, procedureError, sectionMap } from "./constants";

export const handleMarginApiError = (error) => {
  // Extract the backend message safely
  const backendMessage = error;

  // Pick friendly message if mapped, else fallback to backend message or generic error
  return (
    marginErrorMap[backendMessage] ||
    backendMessage ||
    i18n.t("commons.unexpectedError")
  );
};

/**
 * Maps backend printer-related error messages to user-friendly messages.
 * @param {*} msg 
 * @returns 
 */
export const handlePrinterAddEditError = (msg) => {
  const backendMessage = msg;

  // Regex to capture the number 'N' from 'procedure_y_N_invalid'
  const procedureMatch = backendMessage.match(/^procedure_y_(\d+)_invalid$/);

  if (procedureMatch) {
        // This captures number.
        const procedureNumber = procedureMatch[1];
        
        // here Constructs the specific error message
        // Example: "Invalid procedure y-1 axis value provider"
        return i18n.t("systemConfigs.errormessages.invalidProcedureTemplate", { 
            number: procedureNumber 
        });
        
    }

  return procedureError[backendMessage] || i18n.t("systemConfigs.errormessages.invalidData");
}

export const groupCoordinatesBySection = (data = []) => {

  if (!Array.isArray(data)) {
    console.warn("Expected array, received:", typeof data);
    return { grouped: {}, sectionNames: [] };
  }
  
  //// Flatten only if it’s an array of arrays
  const flatData = Array.isArray(data[0]) ? data.flat() : data;

  // Reduce the array into an object grouped by section name
  const grouped = flatData.reduce((acc, item) => {
    // Get the section name from the mapping; default to "Other" if unknown
    const sectionName = sectionMap[item.form_section] || "Other";
    // Initialize the section array if it doesn't exist
    if (!acc[sectionName]) acc[sectionName] = [];
    // Push the current item into the corresponding section group
    acc[sectionName].push(item);
    return acc;
  }, {});

  // Extract just the section names
  const sectionNames = Object.keys(grouped);

  return { grouped, sectionNames};

};

